import { render, staticRenderFns } from "./season_block.vue?vue&type=template&id=5ca1413c&scoped=true"
import script from "./season_block.vue?vue&type=script&lang=js"
export * from "./season_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca1413c",
  null
  
)

export default component.exports